(function() {
  angular
    .module('cfn')
    .controller('sysSeedCustomPopupController', sysSeedCustomPopupController);

  sysSeedCustomPopupController.$inject = ['$scope', '$http', '$location'];

  function sysSeedCustomPopupController($scope, $http, $location) {
    var seedCoreController =
      $scope.$parent.$parent.$parent.$parent.$parent.$parent.$parent
        .seedCoreController;

    $scope.countKeys = function(someObject) {
      if (angular.isObject(someObject)) {
        return Object.keys(someObject).length;
      }
    };

    var init = function() {
        // register onShow in popover component. This is not the angular way of doing it.TODO: find a better way if possible (ASG)
        ang.callInParents($scope, 'registerShowTooltipHandler')(onShow);
      },
      onShow = function() {
        $http
          .get('/365FarmNet/rest/core/sysseed/TemplateOnly')
          .then(function(response) {
            var data = response.data;
            var allCrops = [];
            $scope.model.categories = {};

            data.forEach(function(item) {
              var categoryKey =
                enums.SortCategoryEnum[item.sysCulture_category];
              var itemCategory = $scope.model.categories[categoryKey];
              if (!itemCategory) {
                itemCategory = {
                  name: categoryKey,
                  crops: []
                };
                $scope.model.categories[categoryKey] = itemCategory;
              }

              itemCategory.crops.push(item);
              allCrops.push(item);
            });
            $scope.model.categoryKeys = Object.keys(
              $scope.model.categories
            ).sort();
            //show_all is displayed separately (see html template) and will not be itearated with ngRepeat
            $scope.model.categories['show_all'] = {
              crops: allCrops
            };

            $scope.model.isLoaded = true;
          });

        //default values before data has been loaded
        $scope.model = {
          category: 'show_all',
          activate: true,
          isLoaded: false
        };
      };

    $scope.createNewVariety = function() {
      app.showLoader();

      $http
        .post(
          '/365FarmNet/rest/core/seed/activate_own/' +
            $scope.model.selectedCrop.sysCulture_id
        )
        .then(function(response) {

          // check if there is a valid response containing data
          if (response.data !== '') {
            var data = response.data;
            seedCoreController.updateList();
            $location.path('/core/seed/' + data.seed.id);
          }

          app.hideLoader();
          $scope.closePopup();
        });
    };

    $scope.closePopup = function() {
      ang.callInParents($scope, 'closePopover')();
    };

    init();
    return $scope.sysSeedPopupController;
  }
})();
